import { render, staticRenderFns } from "./EventCreateModule.vue?vue&type=template&id=86d42812&"
import script from "./EventCreateModule.vue?vue&type=script&lang=js&"
export * from "./EventCreateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d42812')) {
      api.createRecord('86d42812', component.options)
    } else {
      api.reload('86d42812', component.options)
    }
    module.hot.accept("./EventCreateModule.vue?vue&type=template&id=86d42812&", function () {
      api.rerender('86d42812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/EventCreateModule.vue"
export default component.exports